<template>
    <section class="sign-in">
        <intro></intro>
        <login></login>
    </section>
</template>

<script>
    import intro from './intro.vue'
    import login from './Login/login.vue'
    export default {
        metaInfo() {
            return {
                title: this.$t('authPageTitle'),
            }
        },
        components: {
            intro,
            login
        }
    }
</script>
<style lang="sass">
    .sign-in
        position: relative
        height: 100%
        width: 100%
        display: flex
</style>